import Image from 'next/image';
import { memo } from 'react';

interface Props {
    icon: string;
    width?: number;
    height?: number;
    name?: string;
    mini?: boolean;
}

const CaseImage = memo(({ icon, width, height, name, mini }: Props) => {
    return (
        <div
            className={`relative h-full w-full rounded-fl-sm bg-layer_2 border border-stroke flex items-center justify-center ${
                mini ? 'p-1' : 'p-1.5'
            }`}
        >
            <Image
                draggable={false}
                src={icon}
                alt=""
                width={width || 96}
                height={height || 96}
                className="object-contain"
                style={{ filter: 'drop-shadow(0 4px 6px rgba(0,0,0,0.35))' }}
            />
            {name && (
                <span className="absolute bottom-1 left-1/2 -translate-x-1/2 text-[11px] text-text_2 font-medium whitespace-nowrap">
                    {name}
                </span>
            )}
        </div>
    );
});

export default CaseImage;
